export default __webpack_public_path__ + "static/199-3cb2f64f546969e94f3b98de5945e6b9.gif";